import { FC } from 'react'
import { Image as ImageType } from '../_methods'
import styled from 'styled-components'
import {
  Carousel as BaseCarousel,
  ImageData,
} from 'components/Common/ImagesCarousel'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  height: 64px;
`

interface CarouselProps {
  images: ImageType[]
}

const Carousel: FC<CarouselProps> = ({ images }) => {
  const carouselImages: ImageData[] = images.map((image, index) => ({
    src: image.imageUrl,
    alt: `Image ${index + 1}`,
    id: index,
  }))

  return (
    <Wrapper>
      <BaseCarousel images={carouselImages} />
    </Wrapper>
  )
}

export default Carousel
